module.exports = __webpack_public_path__ + "media/spence/spence_logo-f1441870.svg";